import { memo, useEffect } from 'react';

import auth from 'app/core/auth';

interface Props {}

export default memo((props: Props) => {
  useEffect(() => {
    const fetchData = async () => {
      const mgr = auth.userManager;
      mgr.signinRedirectCallback().then(
        (user) => {
          window.history.replaceState({}, window.document.title, window.location.origin);
          window.location.href = (user.state as string) || '/';
        },
        (error) => {
          console.error(error);
          if (error.message && error.message === 'No matching state found in storage') {
            window.location.href = '/';
          }
        }
      );
    };
    fetchData();
  }, []);

  return <></>;
});
